var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVolumeOn = function SvgVolumeOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 5 6 9H2v6h4l5 4V5Z",
    stroke: "#9AA0AB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.07 4.93c3.904 3.905 3.904 10.235 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07",
    stroke: "#9AA0AB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgVolumeOn as ReactComponent };
export default "data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M11 5L6 9H2V15H6L11 19V5Z' stroke='%239AA0AB' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E %3Cpath d='M19.0698 4.93005C22.9736 8.83505 22.9736 15.1651 19.0698 19.0701' stroke='%239AA0AB' stroke-width='2' stroke-linecap='round'/%3E %3Cpath d='M15.54 8.45996C17.4919 10.4125 17.4919 13.5775 15.54 15.53' stroke='%239AA0AB' stroke-width='2' stroke-linecap='round'/%3E %3C/svg%3E";